import { timelineActionTypes } from '../actions/timeline-action-types';
import moment from "moment"

var SortedMap = require("collections/sorted-map");

const initialState = {
	data: {offset: 0, count: 0, max: 0, results:[]},
	groupData: new SortedMap(),
	group: [],
	status: "init",
	groupCount: [],
	timelineBreakdown: new SortedMap()
   
};

export const timeline = (state = initialState, action) => {
	switch (action.type) {
		case timelineActionTypes.TIMELINE_REQUESTED:
			return {
				...state,
				status: action.status		
            };
		case timelineActionTypes.TIMELINE_RECEIVED: {
			//todo - incremental fetch and merge
			let allData = [...state.data.results];
			if(allData.length >= (action.data.offset + action.data.results.length)){
				for(let i=0; i< Math.min(action.data.results.length, allData.length + action.data.offset); i++){
					allData[i+action.data.offset] = {...action.data.results[i], index: i+action.data.offset}
				}
			}else {
				for(let i=0;i<action.data.results.length;i++){
					allData.push({...action.data.results[i], index: allData.length+1})
				}
			}
			let grouped = new SortedMap();
			for(let i=0;i<allData.length;i++){
				let year = allData[i].timelineDate.substring(0,4)
				let month = allData[i].timelineDate.substring(0,10)
				let yearData = grouped.get(year)
				if(yearData == null){
					yearData = new SortedMap()
				}
				let monthData = yearData.get(month);
				if(monthData == null){
					monthData = []
				}
				monthData.push(allData[i])
				yearData.set(month, monthData)
				grouped.set(year, yearData)
			}
			return {
				...state,
				data: {...action.data, results: allData},
				groupData: grouped,
				status: action.status

			};
		}
		case timelineActionTypes.TIMELINE_GROUP_COUNT_RECEIVED:
			//Fill in placeholders for the images that will be coming
			return {
				...state,
				data: generatePlaceholderData(action.data),
				groupCount: action.data,
				timelineBreakdown: calculateGroupBreakdown(action.data)

			};
		case timelineActionTypes.TIMELINE_ERROR:
            return {
                ...state
               
        };
		default:
			return state;
	}
};
function generatePlaceholderData(groupCount){
	const data = {offset: 0, count: 0, max: 0, results:[]}
	let count = 0;
	for(let i=0;i<groupCount.length;i++){
		count += groupCount[i][1]
		for(let j=0;j<groupCount[i][1];j++){
			data.results.push({timelineDate: groupCount[i][0],index: data.results.length })
		}
	}
	data.count = count;
	return data;
}
function calculateGroupBreakdown(groupCount){
	try {
		if (groupCount.length === 0) {
			return new SortedMap();
		}
		let totalEvents = groupCount.length;
		let totalPhotos = groupCount.map(it => it[1]).reduce((total, current) => total + current);

		let startDate = new Date(groupCount[0][0]);
		let endDate = new Date(groupCount[groupCount.length - 1][0]);
		let groupBreakdown = new SortedMap();
		// Show at most 10 events on the timeline so it doesn't get overly crowded
		if (totalEvents <= 10) {
			groupBreakdown = groupCount.map(it => {
				let theDate = new Date(it[0]);
				return {
					date: theDate,
					count: it[1],
					percentage: Math.floor((it[1] / totalPhotos) * 100),
					label: moment(theDate).format('MMM, YYYY'),
					link: moment(theDate).format("YYYYMM")
				}
			});
		} else {
			groupBreakdown = extractQuarterBreakdown(groupCount, totalPhotos);
			if (groupBreakdown.length > 10) {
				groupBreakdown = extractYearBreakdown(groupCount, totalPhotos);
			}
		}
		return groupBreakdown
	}catch(e){
		console.log(e, e.stack)
		return new SortedMap()
	}
}

function extractQuarterBreakdown(groupCount, totalPhotos) {
	let quarters = new SortedMap(null,null, (left,right)=>left===right? 0:left > right?-1:1) ;
	for(let i=0; i< groupCount.length; i++){
		let it = groupCount[i]
		let theDate = new Date(it[0]);
		let quarter = Math.floor(theDate.getMonth() / 3);
		let year = theDate.getFullYear();
		let season = "";
		switch (quarter) {
			case 0:
				season = "Spring";
				break;
			case 1:
				season = "Summer";
				break;
			case 2:
				season = "Fall";
				break;
			case 3:
				season = "Winter";
				break;
			default:
				season = "";
				break;
		}
		let key = new Date(year, quarter*3, 1);
		if (quarters.has(key)) {
			let prev = quarters.get(key);
			prev.count += it[1];
			prev.percentage = Math.floor((prev.count / totalPhotos)*100);
			quarters.set(key, prev);
		} else {
			let qVal = {
				date: key,
				count: it[1],
				percentage: Math.floor((it[1] / totalPhotos)*100),
				label: season + " " + year,
				link: `${year}Q${quarter+1}`
			}
			quarters.set(key, qVal);
		}
	}
	return quarters;
}
function extractYearBreakdown(groupCount, totalPhotos) {
	let years = new SortedMap(null, null, (left,right)=>left===right? 0:left > right?-1:1) ;
	groupCount.forEach(it => {
		let theDate = new Date(it[0]);
		let year = theDate.getFullYear();
		let key = new Date(year, 0, 1);
		if (years.has(key)) {
			let prev = years.get(key);
			prev.count += it[1];
			prev.percentage = Math.floor((prev.count / totalPhotos)*100);
			years.set(key, prev);
		} else {
			let qVal = {
				date: key,
				count: it[1],
				percentage: Math.floor((it[1] / totalPhotos)*100),
				label: year.toString(),
				link: `${year}`
			}
			years.set(key, qVal);
		}
	})
	return years;
}


// WEBPACK FOOTER //
// ./src/timeline/reducers/timeline-reducers.js